import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_WDT_CLASSROOM_CHARACTER_ORDER_SETTING = gql`
  mutation updateWdtClassroomSettingCharacterOrder(
    $data: [UpdateWdtClassroomSettingCharacterOrderInput!]!
  ) {
    updateWdtClassroomSettingCharacterOrder(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_WDT_CLASSROOM_CHARACTER_ORDER_SETTING;
